const querystring = require('query-string')

export default () => ({
    url(mode) {
        return `${window.location.pathname}?${querystring.stringify({
            ...querystring.parse(window.location.search),
            layout: mode,
        })}`
    },
})
